import React from 'react';
import './WhatIs.scss';

const features = [
    {
        badge: '01',
        title: 'Szybkie tworzenie nekrologów',
        description: 'Wprowadź dane zmarłej osoby raz, a Nekrodruk przygotuje gotowe materiały w różnych szablonach i formatach.',
    },
    {
        badge: '02',
        title: 'Pełna personalizacja treści',
        description: 'Dopasuj układ, typografię i elementy dekoracyjne do oczekiwań rodziny bez pracy od zera przy każdym zleceniu.',
    },
    {
        badge: '03',
        title: 'Spójny proces pracy',
        description: 'Formularze, szablony i eksport plików pomagają utrzymać porządek od przyjęcia danych po gotowy wydruk.',
    },
];

export default function WhatIs() {
    return (
        <section className='WhatIs' id='WhatIs'>
            <div className='WhatIs_wrapper'>
                <div className='WhatIs_content'>
                    <div className='WhatIs_intro'>
                        <span className='WhatIs_kicker'>O aplikacji</span>
                        <h1 className='WhatIs_title'>Czym jest Nekrodruk?</h1>
                        <p className='WhatIs_lead'>
                            Nekrodruk to aplikacja internetowa wspierająca zakłady pogrzebowe w przygotowywaniu kompletu materiałów dla rodzin.
                            W jednym miejscu przygotujesz <strong>nekrologi, tabliczki, szarfy</strong> oraz inne wydruki bez instalowania dodatkowego
                            oprogramowania.
                        </p>
                        <p className='WhatIs_lead'>
                            W pakiecie otrzymujesz również <strong>generator XML</strong>, <strong>eksport gotowych plików</strong> oraz możliwość zapisu
                            własnych szablonów. Dzięki temu zespół pracuje szybciej, a materiały zachowują jednolity, profesjonalny standard.
                        </p>
                    </div>

                    <div className='WhatIs_features'>
                        {features.map((feature) => (
                            <article key={feature.badge} className='WhatIs_feature'>
                                <span className='WhatIs_featureBadge'>{feature.badge}</span>
                                <h2 className='WhatIs_featureTitle'>{feature.title}</h2>
                                <p className='WhatIs_featureDescription'>{feature.description}</p>
                            </article>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
